module.exports = __webpack_public_path__ + "static/media/edenred-1.c54f9a3f.png";